import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43e1a291"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-grid" }
const _hoisted_2 = {
  key: 0,
  class: "list-page"
}

import { Ref, ref, toRef, watch } from 'vue'
import { goodsShopAdd, goodsShopSetting } from '@/apis/usercenter'
import PopBtn from '@/components/common/PopBtn.vue'
import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'
import { confirmUnlike } from '@/util/useConfirm'
import { ElMessage } from 'element-plus'
import ShopItem from '@/components/common/ShopItem.vue'

interface Item {
  [key: string]: any
}

export default /*#__PURE__*/_defineComponent({
  props: ['pageNum', 'pageSize', 'data', 'loading', 'behaviorChannel', 'type'],
  emits: ['update:pageNum', 'update:pageSize', 'success'],
  setup(__props, { emit }) {

const props = __props


const data = toRef(props, 'data')

const texts = ['找相似', '円', '销量', '件'].map(t)

const list: Ref<Item[]> = ref([])
const total: Ref<number> = ref(0)

watch(data, (v) => {
  list.value = v.records
  v.total && (total.value = v.total)
})

const unlike = (v: any): void => {
  confirmUnlike(
    () => {
      goodsShopSetting({
        behaviorFlag: 2,
        shopCode: v.shopCode,
        behaviorChannel: props.behaviorChannel
      }).then((res: any) => {
        if (res.success) {
          ElMessage.success(t('操作成功'))
          emit('success')
        }
      })
    },
    () => null
  )
}

const addCollect = (v: any) => {
  goodsShopAdd({
    shopCode: v.shopCode
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success('收藏成功')
      emit('success')
    }
  })
}
const bindShop = (v: any) => {
  console.log(v)
}

// 店铺取消收藏
const cancelCollect = (shopCode: string) => {
  if (props.type === 'collect') {
    const index = list.value.findIndex((item: any) => item.shopCode === shopCode)
    list.value.splice(index, 1)
  }
}

// 店铺不喜欢
const itemUnlike = (shopCode: string) => {
  if (props.type === 'look') {
    const index = list.value.findIndex((item: any) => item.shopCode === shopCode)
    list.value.splice(index, 1)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          key: v.shopCode,
          class: "list-item rel"
        }, [
          _createVNode(ShopItem, {
            item: v,
            onCancelCollect: cancelCollect,
            onUnlike: itemUnlike
          }, null, 8, ["item"])
        ]))
      }), 128))
    ]),
    (total.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev,pager,next,sizes,jumper",
            currentPage: __props.pageNum,
            "page-size": __props.pageSize,
            total: total.value,
            onCurrentChange: _cache[0] || (_cache[0] = ($event: any) => (emit('update:pageNum', $event))),
            onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (emit('update:pageSize', $event)))
          }, null, 8, ["currentPage", "page-size", "total"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})